import React, { lazy } from 'react'
import { Redirect } from 'react-router-dom'
import BasicLayout from '../components/layout/BasicLayout'
import routerConstants from '../constants/routerConstants'

const ToDuAnList = () => React.createElement(Redirect, { to: routerConstants.duAn.list })

const routeDuAn: any[] = [
  { path: routerConstants.duAn.list, name: 'duAnList', exact: true, layout: BasicLayout, component: lazy(() => import('../components/admin/duAns/MangChiNhanhPage')), },
  { path: routerConstants.duAn.add, name: 'duAnAdd', exact: true, layout: BasicLayout, component: ToDuAnList, },
  { path: routerConstants.duAn.edit, name: 'duAnEdit', exact: false, layout: BasicLayout, component: ToDuAnList, },
]
export { routeDuAn }
